module.exports = __webpack_public_path__ + "static/media/4ODA8.58512e90.jpg";